exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".headline-20{font-size:16px;font-weight:400;line-height:32px!important;letter-spacing:normal!important}@media (min-width:440px){.headline-20{font-size:20px}}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/agendamento/cancelWarning.vue"],"names":[],"mappings":"AACA,aACE,eAAgB,AAChB,gBAAiB,AACjB,2BAA6B,AAC7B,+BAAkC,CACnC,AACD,yBACA,aACI,cAAgB,CACnB,CACA","file":"cancelWarning.vue","sourcesContent":["\n.headline-20{\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n}\n@media (min-width: 440px)  {\n.headline-20{    \n    font-size: 20px;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3669228a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/agendamento/cancelWarning.vue
// module id = 467
// module chunks = 0 1